/** Prefer blob URL from a pending `File`; else saved absolute/relative URL from the API. */
export function pickLogoPreviewSrc(
  blobUrl: string | undefined,
  serverUrl: string | undefined,
): string | null {
  if (blobUrl) return blobUrl
  const s = serverUrl?.trim()
  return s || null
}
